var util = {};
util.post = function(url, fields) {
    var $form = $('form#phase-3');
    $.each(fields, function(key, val) {
        $('<input>').attr({
            type: "hidden",
            name: key,
            value: val
        }).appendTo($form);
    });
    $form.submit();
}

const lang = $('html').attr('lang');

$.ajaxSetup({headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}});

const datatables_ptbr = {
    "sEmptyTable": "Nenhum registro para exibir",
    "sInfo": "_START_ até _END_ de _TOTAL_ registros",
    "sInfoEmpty": "0 registros",
    "sInfoFiltered": "(Filtrados de _MAX_ registros)",
    "sInfoPostFix": "",
    "sInfoThousands": ".",
    "sLengthMenu": "Mostrar _MENU_ por página",
    "sLoadingRecords": "Carregando...",
    "sProcessing": "Processando...",
    "sZeroRecords": "Não encontramos nenhum resultado para essa busca.",
    "sSearch": "Buscar",
    "oPaginate": {
        "sNext": "Próximo",
        "sPrevious": "Anterior",
        "sFirst": "Primeiro",
        "sLast": "Último"
    },
    "oAria": {
        "sSortAscending": ": Ordenar colunas de forma ascendente",
        "sSortDescending": ": Ordenar colunas de forma descendente"
    }
};

const datatables_en = {
    "sEmptyTable": "No entries",
    "sInfo": "Showing _START_ to _END_ of _TOTAL_ entries",
    "sInfoEmpty": "0 entries",
    "sInfoFiltered": "(Filtered from _MAX_ total entries)",
    "sInfoPostFix": "",
    "sInfoThousands": ".",
    "sLengthMenu": "Show _MENU_ per page",
    "sLoadingRecords": "Loading...",
    "sProcessing": "Processing...",
    "sZeroRecords": "We didn't find any resoluts for this search.",
    "sSearch": "Search",
    "oPaginate": {
        "sNext": "Next",
        "sPrevious": "Previous",
        "sFirst": "First",
        "sLast": "Last"
    },
    "oAria": {
        "sSortAscending": ": Ordenar colunas de forma ascendente",
        "sSortDescending": ": Ordenar colunas de forma descendente"
    }
};

const columns = [
    {
        data: 'artist',
        name: 'artist',
        title: lang == 'pt' ? 'Artista' : 'Artist',
        searchable: true,
        orderable: true,
        width: '40%',
    },
    {
        data: 'jobs',
        name: 'jobs',
        title: lang == 'pt' ? 'Gênero de trabalho' : 'Publishing/work Genre',
        searchable: true,
        orderable: true,
        width: '45%',
    },
    {
        data: 'actions',
        name: 'actions',
        title: '&nbsp',
        searchable: false,
        orderable: false,
        width: '15%',
    },
];

var $tableAvailableArtists = $('#table-available-artists').DataTable({
    sDom: 'lrtip',
    orderCellsTop: true,
    fixedHeader: true,
    oLanguage : lang == 'pt' ? datatables_ptbr : datatables_en,
    order: [[0, "asc"]],
    pageLength: 5,
    columns: columns,
    stateSave: true,
    scrollX: false,
    initComplete: function (settings, json) {

        var api = new $.fn.dataTable.Api(settings);
        var state = api.state.loaded();

        $(this).find('thead').append('<tr role="row" class="filters"></tr>');

        this.api().columns().every(function(colIndex) {

            var th = $('<th></th>').appendTo($('tr.filters'));
            var column = this;
            var column_name = column.dataSrc();


            if(column_name == 'artist') {
                $('<input type="text" class="form-control form-control-sm" placeholder="'+(lang == 'pt' ? 'Buscar' : 'Search')+'" value="'+(state ? state.columns[colIndex].search.search : '')+'" />')
                        .appendTo(th)
                        .on('keyup', function() {

                            if($(this).val() == '') {
                                $(this).removeClass('has-value');
                            } else {
                                $(this).addClass('has-value');
                            }

                            column.search($(this).val(), false, true).draw();

                        });
            }

            if(column_name == 'jobs') {
                var select = $('<select class="form-control form-control-sm"><option value="" selected>'+(lang == 'pt' ? 'Todos' : 'All')+'</option></select>');
                $.each(job_class_items, function(i, e) {
                    let titleLang = lang == 'pt' ? e.replace('. Qual?', '') : e.replace('. Wich one?', '');
                    select.append('<option value="'+titleLang+'" '+(state && state.columns[colIndex].search.search == titleLang ? 'selected' : '')+'>'+titleLang+'</option>');
                });
                select.appendTo(th).on('change', function() {
                    if($(this).val() == '') {
                        $(this).removeClass('has-value');
                    } else {
                        $(this).addClass('has-value');
                    }

                    column.search($(this).val()).draw();
                });
            }
        });
    }
});

datatables_ptbr.sEmptyTable = 'Você não possui notificações';
datatables_en.sEmptyTable = "You don't have notifications";

var $tableInvites = $('#table-invites').DataTable({
    sDom: 'lrtip',
    orderCellsTop: true,
    fixedHeader: true,
    oLanguage : lang == 'pt' ? datatables_ptbr : datatables_en,
    order: [[0, "asc"]],
    pageLength: 5,
    columns: columns,
    stateSave: true,
    scrollX: false,
    initComplete: function (settings, json) {

        var api = new $.fn.dataTable.Api(settings);
        var state = api.state.loaded();

        $(this).find('thead').append('<tr role="row" class="filters-invites"></tr>');

        this.api().columns().every(function(colIndex) {

            var th = $('<th></th>').appendTo($('tr.filters-invites'));
            var column = this;
            var column_name = column.dataSrc();

            if(column_name == 'artist') {
                $('<input type="text" class="form-control form-control-sm" placeholder="'+(lang == 'pt' ? 'Buscar' : 'Search')+'" value="'+(state ? state.columns[colIndex].search.search : '')+'" />')
                        .appendTo(th)
                        .on('keyup', function() {
                            if($(this).val() == '') {
                                $(this).removeClass('has-value');
                            } else {
                                $(this).addClass('has-value');
                            }
                            column.search($(this).val(), false, true).draw();
                        });
            }

            if(column_name == 'jobs') {
                var select = $('<select class="form-control form-control-sm"><option value="" selected>'+(lang == 'pt' ? 'Todos' : 'All')+'</option></select>');
                $.each(job_class_items, function(i, e) {
                    let titleLang = lang == 'pt' ? e.replace('. Qual?', '') : e.replace('. Wich one?', '');
                    select.append('<option value="'+titleLang+'" '+(state && state.columns[colIndex].search.search == titleLang ? 'selected' : '')+'>'+titleLang+'</option>');
                });
                select.appendTo(th).on('change', function() {
                    if($(this).val() == '') {
                        $(this).removeClass('has-value');
                    } else {
                        $(this).addClass('has-value');
                    }

                    column.search($(this).val()).draw();
                });
            }
        });
    }
});

$(document).on('click', '.btn-invite', function(e) {
    e.preventDefault();
    const $btn = $(this);
    const data = {
        action: 'invite-artist',
        artist_subscription_invited_id: $btn.attr('data-artist-subscription-id')
    };

    $.confirm({
        boxWidth: '335px',
        useBootstrap: false,
        title: '',
        content: lang == 'pt' ? '<h2>Confirma essa ação?</h2>' : '<h2>Confirm this action?</h2>',
        buttons: {
            confirm: {
                text: lang == 'pt' ? 'OK' : 'OK',
                btnClass: 'btn-confirm',
                action: function(){
                    $btn.attr('disabled', true).html(lang == 'pt' ? 'Aguarde...' : 'Wait...');
                    util.post(window.location.href, data);
                }
            },
            cancel: {
                text: lang == 'pt' ? 'Cancelar' : 'Cancel',
                btnClass: 'btn-cancel',
                action: function(){
                }
            }
        }
    });
});

$(document).on('click', '.btn-accept-invite', function(e) {
    e.preventDefault();
    const $btn = $(this);
    const btnHtml = $btn.html();
    const data = {
        action: 'accept-invite',
        invite_id: $btn.attr('data-invite-id')
    };

    $.confirm({
        boxWidth: '335px',
        useBootstrap: false,
        title: '',
        content: lang == 'pt' ? '<h2>Confirma essa ação?</h2>' : "<h2>Confirm this action?</h2>",
        buttons: {
            confirm: {
                text: lang == 'pt' ? 'Confirmar' : 'OK',
                btnClass: 'btn-confirm',
                action: function() {
                    $btn.attr('disabled', true).html(lang == 'pt' ? 'Aguarde...' : 'Wait...');
                    util.post(window.location.href, data);
                }
            },
            cancel: {
                text: lang == 'pt' ? 'Cancelar' : 'Cancel',
                btnClass: 'btn-cancel',
                action: function(){
                }
            }
        }
    });

});